(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function($) {
	var parser = require("./parser.js");
	$.NSyslog = $.NSyslog || {};
	$.NSyslog.parse = parser;
})(window);

},{"./parser.js":4}],2:[function(require,module,exports){
const FRX = /[a-zA-Z][a-zA-Z0-9]+=/;
const CEP_FIELDS = [
	"version",
	"deviceVendor",
	"deviceProduct",
	"deviceVersion",
	"deviceEventClassID",
	"name",
	"severity",
	"extension"
]

function splitHeaders(text) {
	var arr = [], map = {};
	var scape = false;
	var fields = 7;
	var curr = "";

	text.split("").forEach(ch=>{
		if(!fields) {
			curr += ch;
		}
		else {
			if(ch=="|") {
				if(scape) {
					scape = false;
					curr += ch;
				}
				else {
					arr.push(curr);
					curr = "";
					fields--;
				}
			}
			else if(ch=="\\") {
				curr += ch;
				scape = !scape;
			}
			else {
				scape = false;
				curr += ch;
			}
		}
	});

	if(curr.length)
		arr.push(curr);

	CEP_FIELDS.forEach((f,i)=>map[f]=arr[i]);
	return map;
}

function splitFields(msg) {
	let tokens = msg.split(" ");
	let map = {};

	let token = null;
	while(tokens.length) {
		if(!token) {
			token = tokens.shift();
			if(token.indexOf('=')>=0) {
				let kv = token.split("=");
				token = kv[0];
				map[token] = kv[1];
			}
			else {
				map[token] = "";
			}
		}
		else {
			let val = tokens.shift();
			if(val.indexOf('=')<0) {
				map[token] += ` ${val}`;
			}
			else {
				token = null;
				tokens.unshift(val);
			}
		}
	}

	return map;
}

module.exports = {
	parse(text) {
		var headers = splitHeaders(text);
		var fields = splitFields(headers.extension || "");
		return {
			headers : headers,
			fields : fields
		}
	}
}

},{}],3:[function(require,module,exports){
const FRX = /[a-zA-Z][a-zA-Z0-9]+=/;
const LEEF_FIELDS = [
	{k:"leefVersion",v1:true,v2:true}, 
	{k:"vendor",v1:true,v2:true}, 
	{k:"product",v1:true,v2:true}, 
	{k:"version",v1:true,v2:true}, 
	{k:"eventID",v1:true,v2:true}, 
	{k:"delimiter",v1:false,v2:true}, 
	{k:"extension",v1:true,v2:true}, 
];
const LLEN = LEEF_FIELDS.length;

function splitHeaders(text) {
	var arr = [], map = {};
	var scape = false;
	var fields = 7;
	var curr = "";

	text.split("").forEach(ch=>{
		if(!fields) {
			curr += ch;
		}
		else {
			if(ch=="|") {
				if(scape) {
					scape = false;
					curr += ch;
				}
				else {
					arr.push(curr);
					curr = "";
					fields--;
				}
			}
			else if(ch=="\\") {
				curr += ch;
				scape = !scape;
			}
			else {
				scape = false;
				curr += ch;
			}
		}
	});

	if(curr.length)
		arr.push(curr);

	const ver = arr[0]=='LEEF:1.0'? 'v1' : 'v2';
	for(let i=0;i<LLEN;i++) {
		let f = LEEF_FIELDS[i];
		if(f[ver]) map[f.k] = arr.shift();
	}

	return map;
}

function splitFields(msg, delimiter) {
	delimiter = delimiter || '\t';
	let tokens = msg.split(delimiter);

	let map = tokens.reduce((map,token)=>{
		let keyval = token.split('=');
		map[keyval[0]] = keyval[1];
		return map;
	},{});

	return map;
}

module.exports = {
	parse(text) {
		var headers = splitHeaders(text);
		var fields = splitFields(headers.extension || "", headers.delimiter);
		return {
			headers : headers,
			fields : fields
		}
	}
}

},{}],4:[function(require,module,exports){
const
	Pri = require("./pri.js"),
	CEF = require("./cef.js"),
	LEEF = require('./leef.js');

const RXS = {
	"pri" : /^<\d+>/,
	"prinmr" : /^\d+ /,
	"prival" : /<(\d+)>/,
	"month" : /^[A-Za-z][a-z]{2} /,
	"day" : /^\d{1,2} /,
	"time" : /^\d+:\d+:\d+ /,
	"ts" : /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\S+ /,
	"invalid" : /[^a-zA-Z0-9\.\$\-_#%\/\[\]\(\)]/,
	"sdata" : /\[(\S+)( [^\=]+\=\"[^\"]*\")+\]/g,
	"asdata" : /^\s*[^\[]+\[/,
	"bsdata" : /^\s*\[/,
	"cef" : /^CEF:\d+/,
	"leef" : /^LEEF:(1|2)\.0/
}

const DOPS = {
	cef : true,
	leef : true,
	fields : true,
	pid : true,
	generateTimestamp: true
}

function peek(arr) {
	do {
		var item = arr.shift();
		if(item===undefined) return item;
		else item = item.trim();
	}while(!item);

	return item;
}

function assign(entry,item) {
	if(!entry.host) entry.host = item.trim();
	else if(!entry.appName) entry.appName = item.trim();
	else if(!entry.pid) entry.pid = item.trim();
	else if(!entry.messageid) entry.messageid = item.trim();
	else if(!entry.structuredData) {
		entry.structuredData = item.trim();
		return false;
	}
	else return true;
}

function parse(line,opts) {
	if(opts)
		opts = Object.assign({},DOPS,opts);
	else
		opts = DOPS;

	var pri = line.match(RXS.pri);
	var entry = {
		originalMessage : line
	};

	// First priority
	if(pri) {
		entry.pri = pri[0];
		entry.prival = parseInt(entry.pri.match(RXS.prival)[1]);
		var prival = Pri.get(entry.prival);
		entry.facilityval = prival.facility;
		entry.levelval = prival.level;
		entry.facility = Pri.FACILITY[prival.facility].id;
		entry.level = Pri.LEVEL[prival.level].id;
	}
	else {
		entry.pri = "";
		entry.prival = NaN;
	}

	//Split message
	var items = line.substring(entry.pri.length).split(" ");

	// Date search
	var endparse = false;
	while(line.length && !endparse) {
		var item = peek(items)+" ";

		// RFC RFC5424
		if(item.match(RXS.prinmr)) {
			entry.version = parseInt(item);
			entry.type = "RFC5424";
			item = peek(items)+" ";
			if(item.match(RXS.ts)) {
				entry.ts = new Date(Date.parse(item.match(RXS.ts)[0].trim()));
			}
		}
		// BSD
		else if(item.match(RXS.month)) {
			entry.type = "BSD";
			var month = item.trim();
			var day = peek(items);
			var time = peek(items);
			var year = new Date().getYear() + 1900
			entry.ts = new Date(Date.parse(year+" "+month+" "+day+" "+time));
		}
		else {
			entry.type = "UNKNOWN";
			items.unshift(item.trim());
		}
		endparse = true;
	}

	// No timestamp
	if(!entry.ts && opts.generateTimestamp) entry.ts = new Date();

	// Is a standard syslog message
	if(entry.type) {
		endparse = false;

		function invalidate(item) {
			items.unshift(item);
			entry.message = items.join(" ");
			endparse = true;
		}

		while(line.length && !endparse) {
			var item = peek(items);
			if(!item) {
				endparse = true;
			}
			else if(item.endsWith(":")){
				let eitem = item.replace(/:$/,"").trim();
				if(eitem.match(RXS.invalid)) {
					invalidate(item);
				}
				else {
					assign(entry,eitem)
					entry.message = items.join(" ");
					endparse = true;
				}
			}
			else if(!items.length) {
				invalidate(item);
			}
			else {
				// Invalid item (malformed message)
				if(item.match(RXS.invalid)) {
					invalidate(item);
				}
				else {
					var r = assign(entry,item.replace(/: $/,"").trim())
					if(r===true) {
						items.unshift(item);
						entry.message = items.join(" ");
						endparse = true;
					}
					else if(r===false) {
						entry.message = items.join(" ");
						endparse = true;
					}
				}
			}
		}
	}
	else {
		entry.message = items.join(" ");
	}

	// Chained hostnames
	entry.chain = (entry.host||"").split("/");
	entry.host = entry.chain.pop();

	// Structured data
	if(entry.type=="RFC5424") {
		// Look if sdata if before or after message
		let bsdata = RXS.bsdata.test(entry.message);
		let asdata = RXS.asdata.test(entry.message);

		var sdata = entry.message.match(RXS.sdata) || [];
		var idx=0;
		entry.structuredData = sdata.map(item=>{
			var map = {}, nokeys = [];
			var lastKey = null;
			idx = entry.message.indexOf(item)+item.length+1;
			item.replace(/(^\[)|(\]$)/g,"").split(" ").forEach((t,i)=>{
				// Extra space
				if(!t.trim()) return;
				// First element (ID of data)
				if(i==0) {
					map["$id"] = t;
				}
				// Key/Pair values
				else {
					var kv = t.split("=");
					// Correct key/value pair
					if(kv[0] && kv[1] && kv[1]!='"') {
						lastKey = kv.shift();
						map[lastKey] = kv.join("=").replace(/\"/g,"");
					}
					// Last key had values separated by spaces
					else if(kv[0] && kv[1]===undefined){
						map[lastKey] += " "+(kv[0]||"").replace(/\"/g,"");
					}
					else if(kv[0] && (!kv[1].length || kv[1]=='"')){
						map[lastKey] += " "+(kv[0]||"").replace(/\"/g,"")+"=";
					}
				}
			});
			return map;
		});

		// Structured data parsed successfuly
		if(entry.structuredData.length) {
			let sidx = entry.message.indexOf("[");
			// sdata before message
			if(bsdata) {
				if(sidx>=0) entry.header = line.substring(0,line.length-entry.message.length);
				entry.message = entry.message.substring(idx);
			}
			// sdata after message
			else if(asdata) {
				if(sidx>=0) {
					entry.header = line.substring(0,line.length-entry.message.length);
					entry.message = entry.message.substring(0,sidx);
				}
			}
		}
	}

	// CEF Event message
	if(opts.cef!==false && RXS.cef.test(entry.message)) {
		entry.type = "CEF";
		let cef = CEF.parse(entry.message);
		entry.cef = cef.headers;
		entry.fields = cef.fields;
	}
	// LEEF Event message
	else if(opts.leef!==false && RXS.leef.test(entry.message)) {
		entry.type = "LEEF";
		let leef = LEEF.parse(entry.message);
		entry.leef = leef.headers;
		entry.fields = leef.fields;
	}
	// Default syslog message
	else if(opts.fields!==false && entry.type!="UNKNOWN"){
		// Message with fields
		var fields = [];
		entry.message.split(",").forEach(kv=>{
			var prop = kv.split("=");
			if(prop.length==2)
				fields[prop[0]] = prop[1];
		});
		entry.fields = fields;
	}

	// header
	entry.header = entry.header || line.substring(0,line.length-entry.message.length);
	entry.message = entry.message.trim();

	// PID
	if(opts.pid && entry.appName && entry.appName.endsWith("]")) {
		let idx = entry.appName.indexOf("[");
		if(idx>=0) {
			entry.pid = entry.appName.substring(idx+1,entry.appName.length-1);
			entry.appName = entry.appName.substring(0,idx);
		}
	}

	return entry;
}

module.exports = function(line,opts) {try {return parse(line,opts)}catch(err){return {err:err}}};

},{"./cef.js":2,"./leef.js":3,"./pri.js":5}],5:[function(require,module,exports){
const FACILITY = [
	{id:"kern", label:"kernel messages"},
	{id:"user", label:"user-level messages"},
	{id:"mail", label:"mail system"},
	{id:"daemon", label:"system daemons"},
	{id:"auth", label:"security/authorization messages"},
	{id:"syslog", label:"messages generated internally by syslogd"},
	{id:"lpr", label:"line printer subsystem"},
	{id:"news", label:"network news subsystem"},
	{id:"uucp", label:"UUCP subsystem"},
	{id:"cron", label:"clock daemon"},
	{id:"authpriv", label:"security/authorization messages"},
	{id:"ftp", label:"FTP daemon"},
	{id:"ntp", label:"NTP subsystem"},
	{id:"security", label:"log audit"},
	{id:"console", label:"log alert"},
	{id:"solaris-cron", label:"clock daemon"},
	{id:"local0", label:"locally used facility 0"},
	{id:"local1", label:"locally used facility 0"},
	{id:"local2", label:"locally used facility 0"},
	{id:"local3", label:"locally used facility 0"},
	{id:"local4", label:"locally used facility 0"},
	{id:"local5", label:"locally used facility 0"},
	{id:"local6", label:"locally used facility 0"},
	{id:"local7", label:"locally used facility 0"}
];

const LEVEL = [
	{id:"emerg", label:"system is unusable"},
	{id:"alert", label:"action must be taken immediately"},
	{id:"crit", label:"critical conditions"},
	{id:"error", label:"error conditions"},
	{id:"warn", label:"warning conditions"},
	{id:"notice", label:"normal but significant condition"},
	{id:"info", label:"informational messages"},
	{id:"debug", label:"debug-level messages"}
]

var FACILITY_MAP = [];
var LEVEL_MAP = [];

FACILITY.forEach((f,i)=>FACILITY_MAP[f.id]=i);
LEVEL.forEach((l,i)=>LEVEL_MAP[l.id]=i);

module.exports.LEVEL = LEVEL;
module.exports.FACILITY = FACILITY;
module.exports.LEVELS = LEVEL_MAP;
module.exports.FACILITIES = FACILITY_MAP;
module.exports.get = function(val1,val2) {
	if(typeof(val1)=="number" && typeof(val2)=="undefined") {
		return {
			level : val1 & 0x7,
			facility : val1 >> 3
		}
	}
	else if(typeof(val1)=="number" && typeof(val2)=="number") {
		return val1*8 + val2;
	}
	else if(typeof(val1)=="string" && typeof(val2)=="number") {
		return (FACILITY_MAP[val1]||0)*8 + val2;
	}
	else if(typeof(val1)=="number" && typeof(val2)=="string") {
		return val1*8 + (LEVEL_MAP[val2]||0);
	}
	else if(typeof(val1)=="string" && typeof(val2)=="string") {
		return (FACILITY_MAP[val1]||0)*8 + (LEVEL_MAP[val2]||0);
	}
	else {
		return {level:0, facility:0}
	}
}

},{}]},{},[1]);
